import { useEffect, useState } from "react";
import { Alert } from "reactstrap";
import { formatCurrency0Digit } from "../../../../utility/Utils";
import Avatar from "@components/avatar";
import "@styles/base/pages/app-ecommerce.scss";
import {
  CheckCircle,
  Delete,
  PieChart,
  Edit,
  Calendar,
} from "react-feather";
import {
  Row,
  Col,
  CardText,
  UncontrolledTooltip,
  FormGroup,
  CustomInput,
  Label,
} from "reactstrap";
import UILoader from "@components/ui-loader";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getCourseDetail, saveCourseRegistration } from "../action";
import DOMPurify from "dompurify";

const MySwal = withReactContent(Swal);

const confirmRegistrationSuccess = ({ title }) => {
  return MySwal.fire({
    title: title,
    text: "",
    icon: "success",
    confirmButtonText: "ตกลง",
    cancelButtonText: "ปิด",
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: true,
  });
};

const confirmRegistrationError = ({ statusCode, statusDesc }) => {
  return MySwal.fire({
    title: "ลงทะเบียนไม่สำเร็จ",
    text: statusDesc,
    icon: "error",
    confirmButtonText: "ตกลง",
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary",
    },
    buttonsStyling: true,
  });
};

const handleConfirmText = ({ callbackFunction, title, text }) => {
  return MySwal.fire({
    title: title,
    text: text,
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "ตกลง",
    cancelButtonText: "ปิด",
    customClass: {
      confirmButton: "btn btn-primary",
      cancelButton: "btn btn-outline-danger ml-1",
    },
    buttonsStyling: false,
  }).then(function (result) {
    if (result.value) {
      callbackFunction();
    }
  });
};

const PaymentDetails = (props) => {
  const {
    payment,
    data,
    transactionCourseUser,
    dispatch,
  } = props;

  const [userData, setUserData] = useState(null);

  const callBackFunctionRegistration = ({ type, data }) => {
    if (data.statusCode === "0" || data.statusCode === 0) {
      confirmRegistrationSuccess({ title: "ลงทะเบียนเรียบร้อย" });
      dispatch({ type: type, data: data });
    } else {
      confirmRegistrationError({
        statusCode: data.statusCode,
        statusDesc: data.statusDesc,
      });
    }
  };

  const callBackFunctionCancel = ({ type, data }) => {
    if (data.statusCode === "0" || data.statusCode === 0) {
      confirmRegistrationSuccess({ title: "ยกเลิกการลงทะเบียนเรียบร้อย" });
      dispatch({ type: type, data: data });
    } else {
      confirmRegistrationError({
        statusCode: data.statusCode,
        statusDesc: data.statusDesc,
      });
    }
  };

  const saveCourseRegistrationAction = () => {
    handleConfirmText({
      callbackFunction: () =>
        saveCourseRegistration({
          courseId: data.id,
          dispatch,
          transactionCourseUserStatus: "WAIT_PAYMENT",
          callBackFunction: callBackFunctionRegistration,
        }),
      title: "ต้องการลงทะเบียน ใช่หรือไม่",
      text: "",
    });
  };

  const cancelCourseRegistrationAction = () => {
    handleConfirmText({
      callbackFunction: () =>
        saveCourseRegistration({
          courseId: data.id,
          dispatch,
          transactionCourseUserStatus: "CANCEL",
          callBackFunction: callBackFunctionCancel,
        }),
      title: "ต้องการยกเลิกการลงทะเบียน ใช่หรือไม่",
      text: "",
    });
  };

  useEffect(() => {
    setUserData(JSON.parse(localStorage.getItem("userData")));
  }, []);

  const invoiceStatusObj = {
    PAYMENT_SUCCESS: {
      color: "light-success",
      icon: CheckCircle,
      text: "อนุมัติการลงทะเบียน",
    },
    APPROVE_SUCCESS: {
      color: "light-success",
      icon: CheckCircle,
      text: "อนุมัติการลงทะเบียน",
    },
    CANCEL: { color: "light-danger", icon: Delete, text: "ยกเลิก" },
    WAIT_PAYMENT: {
      color: "light-warning",
      icon: PieChart,
      text: "รอยืนยันการชำระเงิน",
    },
    WAIT_ADMIN_APPROVE: {
      color: "light-warning",
      icon: PieChart,
      text: "รอตรวจสอบการชำระเงิน",
    },
  };
  const generateCourses = () => {
    const color =
        transactionCourseUser && transactionCourseUser.status
          ? invoiceStatusObj[transactionCourseUser.status].color
          : "primary",
      Icon =
        transactionCourseUser && transactionCourseUser.status
          ? invoiceStatusObj[transactionCourseUser.status].icon
          : Edit;
    const textTooltip =
      transactionCourseUser && transactionCourseUser.status
        ? invoiceStatusObj[transactionCourseUser.status].text
        : "";

    return (
      <Row className="my-2">
        <Col
          className="align-items-center justify-content-center mb-2 mb-md-0"
          md="5"
          xs="12"
        >
          <div className="align-items-center justify-content-center">
            <img
              className="img-fluid card-img-top"
              src={payment.configMasterCode10001.description}
              alt={data.name}
            />
          </div>
        </Col>
        <hr />
        <Col md="7" xs="12">
          <h4>{data.courseName}</h4>

          {userData &&
          data.courseIsMember === true &&
          userData.role === "user" ? (
            <div className="ecommerce-details-price d-flex flex-wrap mt-1">
              <h4 className="item-price mr-1">
                {data.price1 && data.price1 > 0
                  ? "ค่าลงทะเบียน (สมาชิก " +
                    data.memberName +
                    ") " +
                    formatCurrency0Digit(data.price1) +
                    " บาท"
                  : "ฟรี"}
              </h4>
            </div>
          ) : null}

          {userData &&
          data.courseIsMember !== true &&
          userData.role === "user" ? (
            <div className="ecommerce-details-price d-flex flex-wrap mt-1">
              <h4 className="item-price mr-1">
                {data.price2 && data.price2 > 0
                  ? "ค่าลงทะเบียน (สมาชิกนอกเครือข่าย " +
                    data.memberName +
                    ") " +
                    formatCurrency0Digit(data.price2) +
                    " บาท"
                  : "ฟรี"}
              </h4>
            </div>
          ) : null}
          <CardText className="item-description">
            <Avatar
              color={color}
              icon={<Icon size={16} />}
              id={`av-tooltip-${data.id}`}
            />
            <UncontrolledTooltip
              placement="top"
              target={`av-tooltip-${data.id}`}
            >
              <span className="font-weight-bold">{textTooltip}</span>
            </UncontrolledTooltip>
            สถานะการลงทะเบียน : {textTooltip}
          </CardText>
          <CardText className="item-description">
            <Avatar
              color={color}
              icon={<Calendar size={16} />}
              id={`av-tooltip-${data.id}`}
            />
            <UncontrolledTooltip
              placement="top"
              target={`av-tooltip-${data.id}`}
            >
              <span className="font-weight-bold">{textTooltip}</span>
            </UncontrolledTooltip>
            ชำระเงินภายในวันที่ {data.dueDateStr ? data.dueDateStr : "-"}
          </CardText>
          <CardText>
            <div className="demo-spacing-0">
              <Alert color="danger">
                <div className="alert-body">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(payment.configMasterCode10002.description),
                    }}
                  />
                </div>
              </Alert>
            </div>
          </CardText>
        </Col>
      </Row>
    );
  };

  return <div>{generateCourses()}</div>;
};

export default PaymentDetails;
